/** @jsxImportSource @emotion/react */
//import { css } from "@emotion/react"
import DOMPurify from 'dompurify'

type SafeHtmlContentProps = {
    htmlContent?: string;
}
export const SafeHtmlContent: React.FC<SafeHtmlContentProps> = props => {
    //css={css`all:initial;color:unset;`}
    return (<>
        {props.htmlContent && (<>
            <div className="content" dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(props.htmlContent) }}></div>
        </>)}
    </>);
}